function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "pfx33137__a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 0 0.890196 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .015)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#CAC5B8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M460.017 56a7.5 7.5 0 0 0 7.483 6.985 7.5 7.5 0 0 0-7.485 7.984l-.03-.003a7.5 7.5 0 0 0-6.97-7.964l.003-.036a7.5 7.5 0 0 0 6.964-6.964l.035-.002zm-123-56a7.5 7.5 0 0 0 7.483 6.985 7.5 7.5 0 0 0-7.485 7.984l-.03-.003a7.5 7.5 0 0 0-6.97-7.964l.003-.036a7.5 7.5 0 0 0 6.964-6.964l.035-.002zm-148 63a7.5 7.5 0 0 0 7.483 6.985 7.5 7.5 0 0 0-7.485 7.984l-.03-.003a7.5 7.5 0 0 0-6.97-7.964l.003-.036a7.5 7.5 0 0 0 6.964-6.964l.035-.002zm-68 63a7.5 7.5 0 0 0 7.483 6.985 7.5 7.5 0 0 0-7.485 7.984l-.03-.003a7.5 7.5 0 0 0-6.97-7.964l.003-.036a7.5 7.5 0 0 0 6.964-6.964l.035-.002zm-7 164a7.5 7.5 0 0 0 7.483 6.985 7.5 7.5 0 0 0-7.485 7.984l-.03-.003a7.5 7.5 0 0 0-6.97-7.964l.003-.036a7.5 7.5 0 0 0 6.964-6.964l.035-.002zm111 29a7.5 7.5 0 0 0 7.483 6.985 7.5 7.5 0 0 0-7.485 7.984l-.03-.003a7.5 7.5 0 0 0-6.97-7.964l.003-.036a7.5 7.5 0 0 0 6.964-6.964l.035-.002zm371-29a7.5 7.5 0 0 0 7.483 6.985 7.5 7.5 0 0 0-7.485 7.984l-.03-.003a7.5 7.5 0 0 0-6.97-7.964l.003-.036a7.5 7.5 0 0 0 6.964-6.964l.035-.002zm-221 7a7.5 7.5 0 0 0 7.483 6.985 7.5 7.5 0 0 0-7.485 7.984l-.03-.003a7.5 7.5 0 0 0-6.97-7.964l.003-.036a7.5 7.5 0 0 0 6.964-6.964l.035-.002zm-233-73a7.5 7.5 0 0 0 7.483 6.985 7.5 7.5 0 0 0-7.485 7.984l-.03-.003a7.5 7.5 0 0 0-6.97-7.964l.003-.036a7.5 7.5 0 0 0 6.964-6.964l.035-.002zM14.021 183.985c.529 7.82 7.033 13.998 14.979 13.998-8.293 0-15.016 6.73-15.016 15.03 0 .327.01.651.031.973l-.061-.005c.02-.32.03-.642.03-.967 0-7.954-6.172-14.465-13.983-14.996l.004-.07c7.467-.51 13.435-6.484 13.944-13.958l.072-.005zM499.017 256a7.5 7.5 0 0 0 7.483 6.985 7.5 7.5 0 0 0-7.485 7.984l-.03-.003a7.5 7.5 0 0 0-6.97-7.964l.003-.036a7.5 7.5 0 0 0 6.964-6.964l.035-.002zm-7-93a7.5 7.5 0 0 0 7.483 6.985 7.5 7.5 0 0 0-7.485 7.984l-.03-.003a7.5 7.5 0 0 0-6.97-7.964l.003-.036a7.5 7.5 0 0 0 6.964-6.964l.035-.002zm125.004-45.015c.529 7.82 7.033 13.998 14.979 13.998-8.293 0-15.016 6.73-15.016 15.03 0 .327.01.651.031.973l-.061-.005c.02-.32.03-.642.03-.967 0-7.954-6.172-14.465-13.983-14.996l.004-.07c7.467-.51 13.435-6.484 13.944-13.958l.072-.005z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(281 73.985)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-190.075 -61.536)",
  filter: "url(#pfx33137__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  transform: "rotate(66 372.569 214.475)",
  d: "M347.972 266.482L397.166 162.469"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  transform: "rotate(66 326.664 111.907)",
  d: "M345.865 165.985L307.463 57.829"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  transform: "rotate(66 228.1 57.241)",
  d: "M280.679 79.883L175.523 34.6"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  transform: "rotate(66 113.605 132.533)",
  d: "M159.618 98.102L67.592 166.964"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  transform: "rotate(66 97.672 262.49)",
  d: "M105.073 205.467L90.271 319.514"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  transform: "rotate(174 442.632 116.196)",
  d: "M470.567 106.609L414.698 125.784"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  transform: "rotate(174 504.888 83.943)",
  d: "M508.251 82.264L501.524 85.622"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  d: "M291.108 66.093L310.834 11.845"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  transform: "rotate(174 173.453 305.573)",
  d: "M191.226 282.822L155.679 328.325"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  transform: "rotate(174 147.796 77.834)",
  d: "M134.798 51.475L160.794 104.192"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  transform: "rotate(174 107.382 15.19)",
  d: "M105.697 11.658L109.068 18.722"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  transform: "rotate(174 306.435 297.005)",
  d: "M293.437 270.647L319.434 323.364"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  transform: "rotate(174 96.887 200.482)",
  d: "M68.336 195.042L125.438 205.923"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E84A32",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  transform: "rotate(174 5.895 191.867)",
  d: "M0.089 190.713L11.702 193.022"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#E84A32",
  transform: "rotate(174 223.119 218.465)",
  cx: 223.119,
  cy: 218.465,
  rx: 11.233,
  ry: 11.167
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-5 517.812 923.336)",
  stroke: "#EBEDE3",
  strokeWidth: 1.575
}, /*#__PURE__*/React.createElement("path", {
  d: "M208.79 27.08c0 14.958-46.74 27.081-104.398 27.081C46.739 54.161 0 42.038 0 27.081 0 12.124 46.74 0 104.392 0 162.05 0 208.79 12.124 208.79 27.08M8.858 169.708V66.757c0 13.83 43.34 25.04 96.805 25.04 53.46 0 96.8-11.21 96.8-25.04v102.95c0 13.83-43.34 33.083-96.8 33.083-53.465 0-96.805-19.254-96.805-33.083"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 54.791v-27.08c0 14.957 46.74 27.08 104.398 27.08 57.653 0 104.392-12.123 104.392-27.08v27.08c0 14.957-46.74 27.08-104.392 27.08C46.739 81.872 0 69.749 0 54.792"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(7 -113.769 -646.627)",
  stroke: "#CAC5B8",
  strokeWidth: 1.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M250.958 32.497c0 17.948-56.15 32.497-125.418 32.497C56.28 64.994.13 50.445.13 32.497.13 14.548 56.28 0 125.54 0c69.268 0 125.418 14.548 125.418 32.497M10.64 202.595V79.055c0 16.596 52.066 30.047 116.297 30.047 64.223 0 116.29-13.451 116.29-30.047v123.54c0 16.595-52.067 39.7-116.29 39.7-64.23 0-116.297-23.105-116.297-39.7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 64.696V32.199c0 17.949 56.15 32.497 125.418 32.497 69.26 0 125.41-14.548 125.41-32.497v32.497c0 17.948-56.15 32.497-125.41 32.497C56.15 97.193 0 82.644 0 64.696"
})), /*#__PURE__*/React.createElement("path", {
  d: "M127.633 74.59c0 13.388-41.459 24.24-92.604 24.24-51.14 0-92.598-10.852-92.598-24.24 0-13.39 41.459-24.242 92.598-24.242 51.145 0 92.604 10.852 92.604 24.241",
  fill: "#EBEDE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-50.446 200.111v-91.024c0 12.228 38.27 22.139 85.48 22.139 47.206 0 85.476-9.911 85.476-22.139v91.024c0 12.228-38.27 29.251-85.476 29.251-47.21 0-85.48-17.023-85.48-29.25",
  fill: "#CAC5B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-57.569 98.83V74.59c0 13.388 41.459 24.24 92.604 24.24 51.139 0 92.598-10.852 92.598-24.24v24.24c0 13.39-41.459 24.242-92.598 24.242-51.145 0-92.604-10.852-92.604-24.241",
  fill: "#CAC5B8"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-60.255 47.55)",
  stroke: "#544D44",
  strokeWidth: 1.442
}, /*#__PURE__*/React.createElement("path", {
  d: "M190.573 25c0 13.807-42.66 24.998-95.29 24.998C42.662 49.998 0 38.807 0 25 0 11.192 42.661 0 95.284 0c52.628 0 95.29 11.192 95.29 25M7.33 154.443v-93.87c0 12.61 39.38 22.831 87.96 22.831 48.574 0 87.954-10.22 87.954-22.83v93.869c0 12.61-39.38 30.165-87.955 30.165-48.58 0-87.96-17.556-87.96-30.165"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 49.998V25c0 13.808 42.661 25 95.29 25 52.622 0 95.283-11.192 95.283-25v25c0 13.807-42.66 24.998-95.284 24.998C42.661 74.997 0 63.806 0 49.998"
}))));

function SvgGifteratorBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 632,
    height: 355,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifteratorBox);
export default __webpack_public_path__ + "static/media/gifterator-box.a738e7ca.svg";
export { ForwardRef as ReactComponent };